export class EntMtsFilter {

  year: string | null;
  page: number;
  size: number;
  name: string | null;
  managerFullName: string | null;
  territorialUnitIds: number[] | null;
  ownershipFormIds: number[] | null;
  deleted: boolean | null;

  constructor(init?:Partial<EntMtsFilter>) {
    this.name = null;
    this.managerFullName = null;
    this.territorialUnitIds = null;
    this.ownershipFormIds = null;
    this.year = null;
    this.deleted = false;
    this.page = 1;
    this.size = 30;
    if(init){
      Object.assign(this, init)
    }
  }
}

